<template>
<div>
   <component ref="layout" :is="uiconfig.layoutType" :config="uiconfig" :dictData="globalConfig.dictData" :moduleMethod="globalConfig.userModuleMethod"  @doAction="doAction" />
</div>
</template>

<script>
import Base from './base.vue';
import ListDetails from './listdetails.vue';
import LeftListRightDetails from './leftlistrightdetails.vue';
import LeftTreeRightDetails from './lefttreerightdetails.vue';
import LeftListRightList from './leftlistrightlist.vue';
import BillSingleGrid from './billsinglegrid.vue';
import ReportBill from './report.vue';
import LevelReport from './levelreport.vue';
import BirtReport from './birtreport.vue';
export default {
    name:'BillTemplate',
    components: {ListDetails,LeftListRightDetails,LeftTreeRightDetails,BillSingleGrid,LeftListRightList,ReportBill,LevelReport,BirtReport},
    extends: Base,
    data () {
        return {
        
        };
    },
    created() {
        this.init();
        if (this.customInit) {
            this.customInit();
        }
    }
};
</script>



// WEBPACK FOOTER //
// src/components/masterplate/layouttemplate.vue